// import {FiArrowUp} from "react-icons/fi";
import Card from "./Base/Card";
import React from "react";

interface PropsI {
    headText: string;
    mainValue: string;
    percentageDifference?: number;
    value?: string;
    notACurrency?: boolean;
    hideBalance: boolean;
}

const AccountCard = ({ headText, mainValue, percentageDifference, value, notACurrency, hideBalance }: PropsI) => {
    return (
        <Card className="account-card-component card">
            <div className="card_text">
                {headText}
            </div>
            <div className="card_head">
                {notACurrency ? "" : "₦" }{ hideBalance ? " ***" : mainValue}
            </div>
            {/*<div className="card_details">*/}
            {/*    <span className="text-success flex mr-1 items-center">*/}
            {/*        <FiArrowUp className="mr-1" /> {percentageDifference}% </span> vs last month*/}
            {/*</div>*/}
            {value &&
                <div className="card_details">
                <span className="text-success flex mr-1 items-center"></span>&#8358;{value}
                </div>
            }
        </Card>
    )
}
export default AccountCard;